import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requireAdmin = false, requireUser = false, requireSuperAdmin = false }) => {
  const { user, loading, isSuperAdmin } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="spinner mb-4"></div>
          <p className="text-gray-600">Verifying authentication...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && user.role !== 'admin' && user.role !== 'manager-admin') {
    // Super admin should never be redirected to user-dashboard
    if (isSuperAdmin() && user.email === 'admin@mastersunion.org') {
      window.location.href = '/';
      return null;
    }
    return <Navigate to="/user-dashboard" replace />;
  }

  if (requireUser && user.role !== 'user') {
    // Super admin should never access user routes
    if (isSuperAdmin() && user.email === 'admin@mastersunion.org') {
      window.location.href = '/';
      return null;
    }
    return <Navigate to="/" replace />;
  }
  
  // Prevent super admin from accessing user routes even if they somehow get here
  if (isSuperAdmin() && user.email === 'admin@mastersunion.org' && requireUser) {
    window.location.href = '/';
    return null;
  }

  if (requireSuperAdmin && !isSuperAdmin()) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
